import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  BaseDialog,
  useDatePickerColumn,
  useTableColumn,
  BaseButton,
  XrkTableProps,
  useInputColumn,
  XrkTable,
  BaseTextContent
} from 'xrk-components';
import { rechargeRecordList } from '../data-source/apis';
import { PayPassagewayCode } from '@cTypes/bank';
import { formatter, http } from '@/utils';
import appStore from '@/store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-main-recharge-record-dialog',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } },
    payPassagewayCode: { default: 'fyBank' }
  },
  setup(__props: any) {

const props = __props;

const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const getListAjax = params => {
  return rechargeRecordList({
    ...params,
    payPassagewayCode: props.payPassagewayCode,
    functionCode: userInfo.value.functionCode,
    departmentId: userInfo.value.depId
  });
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useInputColumn({
      prop: 'payName',
      label: '账户名称',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    }),
    useDatePickerColumn({
      prop: 'time',
      label: '创建时间',
      config: {
        type: 'datetimerange',
        startPlaceholder: '时间始',
        endPlaceholder: '时间止',
        clearable: true
      },
      listener: {
        onChange: (value, searchObj) => {
          if (!value) {
            searchObj.startDt = '';
            searchObj.endDt = '';
          } else {
            searchObj.startCreateAt = value[0];
            searchObj.endCreateAt = value[1];
          }
        }
      }
    }),
    useInputColumn({
      prop: 'tradeNo',
      label: '流水号',
      config: {
        type: 'text',
        placeholder: '请输入'
      }
    })
  ]
});
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px'
    }),
    useTableColumn({
      label: '打款账户名称',
      prop: 'bankAccName'
    }),
    useTableColumn({
      label: '打款账户号',
      prop: 'bfBankNumber'
    }),
    useTableColumn({
      label: '金额',
      prop: 'amount',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    }),
    useTableColumn({
      label: '流水号',
      prop: 'outTradeNo'
    }),
    useTableColumn({
      label: '日期',
      prop: 'finishPayDt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作',
      render: ({ row }) => {
        const { bankPayVoucherUrl } = row;
        return (
          <>
            {bankPayVoucherUrl && (
              <div>
                <BaseButton
                  type="text"
                  click={async () => {
                    await http.download({
                      url: bankPayVoucherUrl,
                      method: 'GET'
                    });
                  }}
                >
                  下载回执单
                </BaseButton>
              </div>
            )}
          </>
        );
      }
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "880px",
    title: "充值记录",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    showFooter: false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(XrkTable), {
            getListAjax: getListAjax,
            searchConfig: searchConfig.value,
            tableConfig: tableConfig.value
          }, null, 8, ["searchConfig", "tableConfig"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})